/*
 * HrachyaOhanyan Co – approximate prices in the visitor's local currency.
 * Display only: products are sold and charged in the store currency (USD).
 * The local currency comes from the visitor's country (Shopify localization);
 * exchange rates come from Shopify's public rates file, with a public
 * daily-rates file as a fallback, and are cached in the browser for 12 hours.
 */
(function () {
  'use strict';

  var cfg = window.HO_CC || {};
  var base = String(cfg.base || 'USD').toUpperCase();
  var country = String(cfg.country || '').toUpperCase();
  var lang = String(cfg.lang || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();

  var COUNTRY_CURRENCY = {};
  'DZ:DZD,AO:AOA,AC:SHP,BJ:XOF,BW:BWP,BF:XOF,BI:BIF,CM:XAF,CV:CVE,CF:XAF,TD:XAF,KM:KMF,CG:XAF,CD:CDF,CI:XOF,DJ:DJF,EG:EGP,GQ:XAF,ER:ERN,SZ:SZL,ET:ETB,GA:XAF,GM:GMD,GH:GHS,GN:GNF,GW:XOF,KE:KES,LS:LSL,LR:LRD,LY:LYD,MG:MGA,MW:MWK,ML:XOF,MR:MRU,MU:MUR,MA:MAD,MZ:MZN,NA:NAD,NE:XOF,NG:NGN,RW:RWF,ST:STN,SN:XOF,SC:SCR,SL:SLE,SO:SOS,ZA:ZAR,SS:SSP,SH:SHP,SD:SDG,TZ:TZS,TG:XOF,TA:GBP,TN:TND,UG:UGX,EH:MAD,ZM:ZMW,AF:AFN,AZ:AZN,BH:BHD,BD:BDT,BT:INR,BN:BND,KH:KHR,CN:CNY,CX:AUD,CC:AUD,HK:HKD,IN:INR,ID:IDR,IQ:IQD,IL:ILS,JP:JPY,JO:JOD,KZ:KZT,KW:KWD,KG:KGS,LA:LAK,LB:LBP,MO:MOP,MY:MYR,MV:MVR,MN:MNT,MM:MMK,NP:NPR,OM:OMR,PK:PKR,PS:ILS,PH:PHP,QA:QAR,RU:RUB,SA:SAR,SG:SGD,KR:KRW,LK:LKR,TW:TWD,TJ:TJS,TH:THB,TM:TMT,AE:AED,UZ:UZS,VN:VND,YE:YER,AI:XCD,AG:XCD,AW:AWG,BS:BSD,BB:BBD,BZ:BZD,BM:BMD,KY:KYD,CR:CRC,CW:XCG,DM:XCD,DO:DOP,GD:XCD,GT:GTQ,HT:HTG,HN:HNL,JM:JMD,MQ:EUR,MS:XCD,NI:NIO,PA:PAB,SX:XCG,BL:EUR,KN:XCD,LC:XCD,MF:EUR,PM:EUR,VC:XCD,TT:TTD,AX:EUR,AL:ALL,AD:EUR,AM:AMD,AT:EUR,BY:BYN,BE:EUR,BA:BAM,BG:EUR,HR:EUR,CY:EUR,CZ:CZK,DK:DKK,EE:EUR,FO:DKK,FI:EUR,FR:EUR,GE:GEL,DE:EUR,GI:GIP,GR:EUR,GL:DKK,GP:EUR,GG:GBP,HU:HUF,IS:ISK,IE:EUR,IM:GBP,IT:EUR,JE:GBP,XK:EUR,LV:EUR,LI:CHF,LT:EUR,LU:EUR,MK:MKD,MT:EUR,YT:EUR,MD:MDL,MC:EUR,ME:EUR,NL:EUR,NO:NOK,PL:PLN,PT:EUR,RE:EUR,RO:RON,SM:EUR,RS:RSD,SK:EUR,SI:EUR,ES:EUR,SJ:NOK,SE:SEK,CH:CHF,TR:TRY,UA:UAH,GB:GBP,VA:EUR,CA:CAD,MX:MXN,AU:AUD,CK:NZD,FJ:FJD,PF:XPF,KI:AUD,NR:AUD,NC:XPF,NZ:NZD,NU:NZD,NF:AUD,PG:PGK,PN:NZD,WS:WST,SB:SBD,TK:NZD,TO:TOP,TV:AUD,VU:VUV,WF:XPF,TF:EUR,GS:GBP,AR:ARS,BO:BOB,BR:BRL,CL:CLP,CO:COP,FK:FKP,GF:EUR,GY:GYD,PY:PYG,PE:PEN,SR:SRD,UY:UYU,VE:VES'.split(',').forEach(function (pair) {
    var kv = pair.split(':');
    COUNTRY_CURRENCY[kv[0]] = kv[1];
  });
  var LANGUAGE_CURRENCY = { de: 'EUR', es: 'EUR', ru: 'RUB' };

  var target = country ? COUNTRY_CURRENCY[country] : LANGUAGE_CURRENCY[lang];
  try {
    var forced = new URLSearchParams(window.location.search).get('ho_cur');
    if (forced && /^[A-Za-z]{3}$/.test(forced)) target = forced.toUpperCase();
  } catch (e) {}
  if (!target || target === base) return;

  var NOTES = {
    en: 'Approximate price in {c}. You will be charged in {b}.',
    de: 'Ungefährer Preis in {c}. Die Zahlung erfolgt in {b}.',
    es: 'Precio aproximado en {c}. El pago se realiza en {b}.',
    ru: 'Примерная цена в {c}. Оплата производится в {b}.'
  };
  var note = (NOTES[lang] || NOTES.en).replace('{c}', target).replace('{b}', base);

  var formatter;
  try {
    formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: target,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  } catch (e) {
    return;
  }

  var CACHE_KEY = 'ho_fx_v1';
  var MAX_AGE = 12 * 60 * 60 * 1000;

  function usable(rates) {
    return rates && rates[target] > 0 && rates[base] > 0 ? rates : null;
  }

  function readCache() {
    try {
      var c = JSON.parse(window.localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.r && Date.now() - c.t < MAX_AGE) return c.r;
    } catch (e) {}
    return null;
  }

  function writeCache(rates) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), r: rates }));
    } catch (e) {}
  }

  /* Rates are normalised to "units of currency per 1 USD". */
  function fromShopify() {
    return new Promise(function (resolve, reject) {
      if (window.Currency && window.Currency.rates) return resolve(window.Currency.rates);
      var script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
      script.async = true;
      script.onload = function () {
        if (window.Currency && window.Currency.rates) resolve(window.Currency.rates);
        else reject(new Error('no rates'));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    }).then(function (valueInUsd) {
      var rates = { USD: 1 };
      Object.keys(valueInUsd).forEach(function (code) {
        var v = Number(valueInUsd[code]);
        if (v > 0) rates[code.toUpperCase()] = 1 / v;
      });
      return rates;
    });
  }

  function fromJson(url) {
    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var src = data && data.usd;
        if (!src) throw new Error('bad data');
        var rates = { USD: 1 };
        Object.keys(src).forEach(function (code) {
          var v = Number(src[code]);
          if (v > 0) rates[code.toUpperCase()] = v;
        });
        return rates;
      });
  }

  function getRates() {
    var cached = usable(readCache());
    if (cached) return Promise.resolve(cached);
    var sources = [
      fromShopify,
      function () { return fromJson('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.min.json'); },
      function () { return fromJson('https://latest.currency-api.pages.dev/v1/currencies/usd.min.json'); }
    ];
    var chain = Promise.reject(new Error('start'));
    sources.forEach(function (source) {
      chain = chain.catch(function () {
        return source().then(function (rates) {
          if (!usable(rates)) throw new Error('missing currency');
          return rates;
        });
      });
    });
    return chain.then(function (rates) {
      writeCache(rates);
      return rates;
    });
  }

  function injectStyles() {
    if (document.getElementById('ho-currency-styles')) return;
    var style = document.createElement('style');
    style.id = 'ho-currency-styles';
    style.textContent =
      '.ho-approx{display:inline-block;margin-inline-start:.5em;font-size:.85em;font-weight:400;opacity:.72;white-space:nowrap}' +
      '.ho-approx-note{display:block;margin-top:.3em;font-size:.75rem;font-weight:400;line-height:1.35;opacity:.65}' +
      '.sticky-add-to-cart__price .ho-approx,.sticky-add-to-cart__price .ho-approx-note{display:none}';
    document.head.appendChild(style);
  }

  function render(rate) {
    var nodes = document.querySelectorAll('[data-ho-cents]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cents = parseInt(el.getAttribute('data-ho-cents'), 10);
      if (!(cents > 0)) continue;
      var text = '≈ ' + formatter.format((cents / 100) * rate);
      var approx = null;
      for (var j = 0; j < el.children.length; j++) {
        if (el.children[j].classList.contains('ho-approx')) approx = el.children[j];
      }
      if (!approx) {
        approx = document.createElement('span');
        approx.className = 'ho-approx';
        approx.title = note;
        el.appendChild(approx);
        if (el.hasAttribute('data-ho-main') && !el.closest('.sticky-add-to-cart__price')) {
          var small = document.createElement('small');
          small.className = 'ho-approx-note';
          small.textContent = note;
          el.appendChild(small);
        }
      }
      if (approx.textContent !== text) approx.textContent = text;
    }
  }

  function start() {
    getRates()
      .then(function (rates) {
        var rate = rates[target] / rates[base];
        if (!(rate > 0)) return;
        injectStyles();
        render(rate);
        var queued = false;
        new MutationObserver(function () {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(function () {
            queued = false;
            render(rate);
          });
        }).observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {
        /* No rates available: keep showing store prices only. */
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
